module.exports = __webpack_public_path__ + "img/logo-live-white.bc174c98.svg";